import React from 'react';

const EmptyCart = () => {
    return (
        <div className="container my-5">
            <div className="row">
                <div className="col-10 mx-auto text-center">
                    <h1 style={{height:"30vh"}}>You Cart Is Curruntly Empty</h1>
                </div>
            </div>
        </div>
    );
}

export default EmptyCart;
